import * as React from 'react'
import { ApolloConsumer, Query, QueryResult } from 'react-apollo'
import uuid from 'uuid/v1'

import Loader from 'main/components/common/Loader'
import { DETAILED_PRICING_MODAL_QUERY } from './gql'
import ViewDetailedPricing from './steps/ViewDetailedPricing'
import { track } from './track'

interface IProps {
  schoolId: number
}

export default function Content(props: IProps) {
  const { schoolId } = props
  const [sessionId] = React.useState(uuid())
  const trackData = { schoolId, sessionId }

  React.useEffect(() => track('opened', trackData), [])

  return (
    <ApolloConsumer>
      {() => (
        <Query query={DETAILED_PRICING_MODAL_QUERY} variables={{ schoolId }}>
          {(result: QueryResult) => {
            const { loading, error, data } = result

            if (loading || error || !data) {
              return <Loader />
            }

            const { school, schoolTuitionPrograms: tuitionPrograms } = data

            if (!school) {
              throw new Error('no school')
            }

            if (!tuitionPrograms) {
              throw new Error('no tuition programs')
            }

            return <ViewDetailedPricing school={school} tuitionPrograms={tuitionPrograms} />
          }}
        </Query>
      )}
    </ApolloConsumer>
  )
}
